import React from "react";
import { Route, Switch } from "react-router";
import ProtectedRoute from "./protectedRoutes";
import MainPage from "../components/Factory/Pages/Common/mainPage";
import forceLogout from "../components/Factory/Pages/Common/forceLogout";
import CallbackPage from "../components/Utils/Oidc/Callback";
import UserProfile from "../components/Factory/Pages/Common/UserProfile";
import ApplicationSettings from "../components/Factory/Pages/Common/ApplicationSettings";
import P_PageLayout from "./../components/Factory/Pages/Common/PageLayout/P_PageLayout";
import PageNotFound from "./PageNotFound";
import homePage from "../components/Factory/Pages/Common/homePage";
import ProfessionalContacts from "../components/Factory/Pages/Common/ProfessionalContacts/ProfessionalContacts";
import ProfessionalDetails from "../components/Factory/Pages/Common/ProfessionalDetails/ProfessionalDetails";
import Provision from "../components/Factory/Pages/Common/Provision/Provision";
// commenting unused routes
// import M_Playground from "../components/Factory/Molecules/Common/M_Playground";
// import Layout from "../components/Factory/Pages/Common/Layouts/M_Layout";
// import M_Layout from "../components/Factory/Pages/Common/Layouts/M_Layout";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={homePage} />
      <Route path="/callback" component={CallbackPage} />
      <ProtectedRoute path="/dashboard" component={MainPage} />
      <ProtectedRoute path="/securelogout" component={forceLogout} />
      {/* <ProtectedRoute path="/playground" component={M_Playground} />
      <ProtectedRoute path="/cardlayout" component={M_Layout} />
      <ProtectedRoute path="/layout" component={Layout} /> */}
      <ProtectedRoute path="/user_profile" component={UserProfile} />
      <ProtectedRoute path="/app_settings" component={ApplicationSettings} />
      {/*
        Professional Contacts / Professional Details (DF154-179) / Provision (Story 56425) —
        deep-link routes matching the manifests in src/cards/*.card.js, for local dev/QA against
        the Prism mock and as a direct URL for each card without needing a backend page/template
        row yet. The real, config-driven mount point is the card registry (M_CustomCards.jsx,
        customCardName minerva.professional-contacts / minerva.loan-professional-details /
        loan-provision) — a platform/config change (cards.config.json) places them in the live
        menu; these routes just make them reachable today. Must stay ABOVE the generic
        /:pageUrl/:crmId/:templateId? route below, which would otherwise swallow
        /loans/:loanId/professional-details or /loans/:loanId/provision first.
      */}
      <ProtectedRoute exact path="/loans/:loanId/provision" component={Provision} />
      <ProtectedRoute
        exact
        path="/professional-contacts"
        component={ProfessionalContacts}
      />
      <ProtectedRoute
        exact
        path="/loans/:loanId/professional-details"
        component={ProfessionalDetails}
      />
      <ProtectedRoute
        path="/:pageUrl/:crmId/:templateId?"
        component={P_PageLayout}
      />
      <Route path="*" component={PageNotFound} />
    </Switch>
  );
}
